// components/SuccessDialog.tsx
import { DialogContentNoClose, DialogHeader } from "@/components/ui/dialog";
import { HausButton } from "@/components/ui/hausbutton";
import { cn } from "@/lib/utils";
import { Dialog, DialogDescription, DialogTitle } from "@radix-ui/react-dialog";
import { Link } from "@remix-run/react";
import { Check } from "lucide-react";

type Props = {
    open: boolean;
};

export function SuccessDialog({ open }: Props) {
    return (
        <Dialog open={open}>
            <DialogContentNoClose className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>
                        <div className="flex justify-center mb-6">
                            <div className={cn("rounded-full p-4 bg-hausspringgreen")}>
                                <Check size={48} className="text-white" />
                            </div>
                        </div>
                    </DialogTitle>
                    <DialogDescription className="text-black">
                        <div className="mb-3 mt-9 text-center">
                            <h1 className="text-3xl font-semibold mb-2">Password Reset</h1>
                            <p className="text-lg font-light">
                                Your password has been successfully reset.
                            </p>
                        </div>
                    </DialogDescription>
                </DialogHeader>
                <div className="w-full">
                    <HausButton asChild className="w-full">
                        <Link to="/login">Back to login</Link>
                    </HausButton>
                </div>
            </DialogContentNoClose>
        </Dialog>
    );
}
export default SuccessDialog;